/**
 * A tela apresentada, no palco: ocupa o palco inteira (sem cortar) e a câmera do outro lado (`camera`) vira uma miniatura no
 * canto. Vale para a tela do outro lado e para a de quem apresenta, como no Google Meet: quem compartilha a tela toda vê o
 * espelho infinito, e é o esperado. O aviso de quem está apresentando (com o atalho para parar) fica na `RoomStatusStack`.
 */
import { isTrackReference, VideoTrack } from '@livekit/components-react';
import { cn } from '@/lib/utils';
import { RemoteTile } from './ParticipantTile';

/** A tela apresentada (de qualquer lado) ocupa o palco; a câmera do outro lado (`camera`) vira miniatura. */
export function SharedScreen({ trackRef, camera, thumbClassName, thumbPosition }) {
    return (
        <div data-screen-share="" className="absolute inset-0 overflow-hidden rounded-[inherit] bg-black">
            {isTrackReference(trackRef) && (
                <VideoTrack trackRef={trackRef} data-screen-share-video="" className="absolute inset-0 h-full w-full object-contain" />
            )}
            {camera && (
                <div className={cn('absolute z-10 aspect-video overflow-hidden rounded-xl border border-white/20 shadow-lg', thumbClassName, thumbPosition)}>
                    <RemoteTile trackRef={camera} size="sm" />
                </div>
            )}
        </div>
    );
}
